import React, { useState } from "react";
import { Btn, P, Image } from "../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import { SignIn } from "../../Constant";
import imgg from "../../assets/images/logo/logo.png";

const ROLE_CONFIG = {
  site_owner: {
    title: "Asset Owner",
    description:
      "I am responsible for ensuring assets at a site or building are tested, maintained, and compliant, and I need to manage their records.",
    points: [
      "Register and manage assets and logbooks",
      "Track asset lifecycle and status",
      "View compliance and test reports",
      "Manage internal users and stakeholders",
      "Invite service providers and allocate tasks",
    ],
    youselected: "",
    route: "/registerassetowner",
  },
  electrician: {
    title: "Service Provider",
    description:
      "I am a service provider invited by an asset owner to register on Know Your Asset and carry out testing and maintenance tasks.",
    points: [
      "Receive and action testing, maintenance, and repair tasks from asset owners",
      "Manage assigned tasks within your organisation",
      "Assist asset owners in keeping logbooks and asset information up to date",
      "View task and asset history",
    ],
    youselected: "Service Provider",
    route: "/registerserviceprovider",
  },
  spao: {
    title: "Asset Owner & Service Provider",
    description:
      "I am a service provider company using Know Your Asset within my own business to manage assets, testing and compliance for my customers.",
    points: [
      "Use a unified dashboard for end-to-end management in Know Your Asset",
      "Create and manage asset logbooks",
      "Allocate testing and maintenance tasks to internal staff",
      "Produce test results and PDF reports for customers",
      "Manage external users and stakeholders",
    ],
    youselected: "Asset Owner & Service Provider",
    route: "/registeraosp",
  },
};

const Register = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState("");
  const [step, setStep] = useState(1);

  const handleContinue = () => {
    if (selectedRole) setStep(2);
  };

  const handleConfirm = () => {
    navigate(`${process.env.PUBLIC_URL}${ROLE_CONFIG[selectedRole].route}`, {
      state: selectedRole,
    });
  };

  return (
    <Container fluid className="p-0">
      <Row>
        <Col xl="12">
          <div className="login-card">
            <div className="login-main1 login-tab1 text-center">
              {/* Logo */}
              <div className="login-header mb-4">
                <Image
                  attrImage={{
                    className: "img-fluid",
                    src: imgg,
                    alt: "logo",
                  }}
                />
              </div>

              {step === 1 && (
                <>
                  <h4 className="mb-3">Know Your Asset</h4>
                  <P className="mb-4">What best describes you?</P>

                  {Object.keys(ROLE_CONFIG).map((key) => (
                    <div
                      key={key}
                      className="text-start mb-3 p-3 border rounded"
                    >
                      <label className="d-flex gap-2">
                        <input
                          type="radio"
                          name="role"
                          value={key}
                          checked={selectedRole === key}
                          onChange={(e) => setSelectedRole(e.target.value)}
                        />
                        <div>
                          <strong>{ROLE_CONFIG[key].title}</strong>
                          <div className="text-muted">
                            {ROLE_CONFIG[key].description}
                          </div>
                        </div>
                      </label>
                    </div>
                  ))}

                  <Btn
                    attrBtn={{
                      color: "primary",
                      className: "mt-3",
                      disabled: !selectedRole,
                      onClick: handleContinue,
                    }}
                  >
                    Continue
                  </Btn>

                  <P className="mt-4">
                    Already have an account?
                    <Link to={`${process.env.PUBLIC_URL}/login`}>{SignIn}</Link>
                  </P>
                </>
              )}
              {step === 2 && (
                <>
                  <h4 className="mb-4">Confirm Your Selection</h4>

                  <div
                    style={{
                      maxWidth: "360px",
                      margin: "0 auto",
                      textAlign: "left",
                    }}
                  >
                    {/* <p className="mb-2">
                      <strong className="ms-2">
                        {ROLE_CONFIG[selectedRole].title}
                      </strong>
                    </p>

                    <p className="text-muted ms-2 mb-3">
                      {ROLE_CONFIG[selectedRole].description}
                    </p> */}

                    <p className="mt-3 mb-2">
                      <strong>
                        As an {ROLE_CONFIG[selectedRole].title}, you will be
                        able to:
                      </strong>
                    </p>
                    <p className="mt-3 mb-2">
                      {ROLE_CONFIG[selectedRole].youselected != "" ? (
                        <strong>
                          You selected: {ROLE_CONFIG[selectedRole].youselected}
                        </strong>
                      ) : (
                        <></>
                      )}
                    </p>

                    {ROLE_CONFIG[selectedRole].points.map((item, idx) => (
                      <div key={idx} className="d-flex align-items-start mb-1">
                        <span style={{ marginRight: "8px" }}>•</span>
                        <span>{item}</span>
                      </div>
                    ))}

                    <p className="text-muted mt-3">
                      You can change this later from Settings.
                    </p>
                  </div>

                  <div className="d-flex justify-content-center gap-3 mt-4">
                    <Btn
                      attrBtn={{
                        color: "primary",
                        onClick: () => setStep(1),
                      }}
                    >
                      Go Back
                    </Btn>

                    <Btn
                      attrBtn={{
                        color: "primary",
                        onClick: handleConfirm,
                      }}
                    >
                      Confirm & Continue
                    </Btn>
                  </div>
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;
